<div class="isg-full-page-header">

  <div class="isg-page-header">
    <span>Welcome</span>
  </div>
  <div class="isg-page-body">

    <h1>Default - Home Page</h1>
    <p>This project supports standalone components. It is recommended to avoid modules and add your own code in a self contained features folder that you can create for your project. See 'admin' and 'widgets' for guidance.</p>
    <p>Please do not use this home component directly. Create your own page component in your features folder for your application and reuse the code from here as an example. </p>
    <p>The same also applies if you wish to update &amp; use your own login page and to reuse the existing code.</p>
    <p>Conversion &amp; further refactoring of existing admin components to page parents is wip.</p>

  </div>
</div>
